if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      };

      // safe fallback untuk matchMedia
      this.mql = window.matchMedia ? window.matchMedia('(min-width: 750px)') : { matches: false };

      if (!this.elements.thumbnails || !this.elements.viewer) return;

      // pastikan debounce ada
      if (typeof debounce === 'function') {
        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      } else {
        // tanpa debounce tetap pasang listener
        this.elements.viewer.addEventListener('slideChanged', this.onSlideChanged.bind(this));
      }

      // pasang click pada thumbnail buttons (safe)
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        const btn = mediaToSwitch.querySelector('button');
        if (btn) {
          btn.addEventListener('click', () => {
            const target = mediaToSwitch.dataset.target;
            if (target) this.setActiveMedia(target, false);
          });
        }
      });

      // safe check sebelum memanggil includes
      if (this.dataset.desktopLayout && this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) {
        this.removeListSemantic();
      }
    }

    onSlideChanged(event) {
      if (!event?.detail?.currentElement) return;
      const mediaId = event.detail.currentElement.dataset.mediaId;
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      if (thumbnail) this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      if (!mediaId) return;
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      if (!activeMedia) return;

      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          if (activeThumbnail && activeThumbnail.parentElement) activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider && typeof this.elements.viewer.resetPages === 'function') {
          this.elements.viewer.resetPages();
        }
      }

      this.preventStickyHeader();

      window.setTimeout(() => {
        if (this.elements.thumbnails && activeMedia.parentElement) {
          // safe scroll
          try { activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft }); } catch (e) {}
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          try { activeMedia.scrollIntoView({ behavior: 'smooth' }); } catch (e) {}
        }
      });

      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      if (activeThumbnail) {
        this.setActiveThumbnail(activeThumbnail);
        // announcement
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      const btn = thumbnail.querySelector('button');
      if (btn) btn.setAttribute('aria-current', 'true');

      // jika ada method isSlideVisible di slider
      if (typeof this.elements.thumbnails.isSlideVisible === 'function') {
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;
        if (this.elements.thumbnails.slider && typeof this.elements.thumbnails.slider.scrollTo === 'function') {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      } else {
        // fallback scroll
        try { thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest' }); } catch (e) {}
      }
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image || !this.elements.liveRegion) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', 'false');
        this.elements.liveRegion.innerHTML = (window.accessibilityStrings?.imageAvailable || 'Image [index] available').replace('[index]', position || '');
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', 'true');
        }, 2000);
      };
      // trigger onload in case already loaded
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      if (!activeItem) return;
      if (typeof window.pauseAllMedia === 'function') window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia && typeof deferredMedia.loadContent === 'function') deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer?.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      if (Array.isArray(this.elements.viewer.sliderItems)) {
        this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
      }
    }
  });
}
